import { defineStore } from 'pinia'
import { ref } from 'vue'
import axios from 'axios'
import {
  settingsApiFactory,
  type IUnauthenticatedRealmSettings,
} from 'pegasus-service'

export const useRealmSettings = defineStore('realmSettings', () => {
  const realmSettings = ref<IUnauthenticatedRealmSettings | undefined>()

  async function load(baseUrl: string) {
    const axiosClient = axios.create({
      baseURL: __PROXY_HOST__?.host ?? baseUrl,
    })
    const settingsApi = settingsApiFactory(axiosClient)

    if (baseUrl) {
      const { data } = await settingsApi.get()
      realmSettings.value = data
    }
  }

  return { realmSettings, load }
})
